import { Table, Status, StatusType, CopyButton, HeadItemType } from 'components'
import { URL_CONST } from 'constants/urls'
import {
  DraftProps,
  StatusOV,
  StatusOVValues
} from 'container/Home/components/Banners/interface'
import CheckedOVsVerification from 'container/ManageOrders/components/CheckedOVsVerification'
import OvMenu from 'container/ManageOrders/components/OvMenu'
import { Dispatch, SetStateAction, useState } from 'react'
import { SapOptionsToOvStatus } from 'store/OVContext/ovContextTypes'
import { useSelector, useDispatch } from 'store/store'
import * as S from './styles'
import { setCheckedOvs, asyncSetOvSap } from 'store/SalesOrderContext/salesOrderSlice'
import SapModal, { SapModalTypes } from 'container/ManageOVDetails/components/SapModal'

import {
  getEDIRowIcon,
  getHavaRowIcon,
  GetNegDif,
  getNegDifRowIcon
} from 'container/ManageOrders/utils'

type ViewByOvProps = {
  draftsData: DraftProps[]
  setDraftsData: Dispatch<SetStateAction<DraftProps[]>>
  ovsSapData: SapOptionsToOvStatus
  setOvsSapData: Dispatch<SetStateAction<SapOptionsToOvStatus>>
}
const ViewByOv = ({
  draftsData,
  setOvsSapData,
  setDraftsData,
  ovsSapData
}: ViewByOvProps) => {
  const { checkedOvs } = useSelector(({ salesOrder }) => salesOrder)
  const [sapModal, setSapModal] = useState<SapModalTypes | undefined>()

  const dispatch = useDispatch()

  const headTable: HeadItemType[] = [
    {
      label: 'Status',
      columnName: 'Status'
    },
    {
      label: 'Pedido Portal',
      columnName: 'NumeroPedidoRascunho'
    },
    {
      label: 'Pedido Cliente',
      columnName: 'NumeroPedidoCliente'
    },
    {
      label: 'Razão social',
      columnName: 'RazaoSocialCliente'
    },
    {
      label: 'Ordem de Venda',
      columnName: 'NumeroOrdemVenda'
    },
    {
      label: 'Datas',
      columnName: 'DataEntregaCalculada'
    },
    {
      label: 'Fábrica',
      columnName: 'Fabrica'
    },
    {
      label: '',
      columnName: ''
    }
  ]

  const toggleCheckOv = (isChecked: boolean, id?: string) => {
    if (id) {
      const updatedOvsData = draftsData.map((ov) =>
        ov.NumeroOrdemVenda === id ? { ...ov, checked: isChecked } : ov
      )
      const updatedCheckedOvs = updatedOvsData.filter((ov) => ov.checked)
      dispatch(setCheckedOvs(updatedCheckedOvs))
      setDraftsData(updatedOvsData)
    } else {
      const updatedOvsData = draftsData.map((ov) => ({ ...ov, checked: isChecked }))
      const updatedCheckedOvs = updatedOvsData.filter((ov) => ov.checked)
      dispatch(setCheckedOvs(updatedCheckedOvs))
      setDraftsData(updatedOvsData)
    }
  }

  const handleOvsSAP = () => {
    dispatch(
      asyncSetOvSap({
        type: ovsSapData.type,
        body: ovsSapData.body
      })
    )
  }

  return (
    <>
      {!!checkedOvs.length && (
        <CheckedOVsVerification
          setSapModal={setSapModal}
          ovsSapData={ovsSapData}
          setOvsSapData={setOvsSapData}
        />
      )}
      <Table
        hasCheckbox
        setChecked={toggleCheckOv}
        bodyData={draftsData.map((draft, index) => {
          const label: StatusOVValues = StatusOV[draft.StatusOrdemVenda]
          const statusType = label.split(' - ')[0] as StatusType
          const ovsNegDifInfo: GetNegDif = {
            flag: draft.FlagNegociacaoDiferenciada,
            isJustified: draft.DataJustificativa,
            ovStatus: +draft.StatusOrdemVenda.split('-')[0]
          }
          return {
            id: `${draft.NumeroOrdemVenda}`,
            checked: draft.checked,
            linkNavigate: `${URL_CONST.MANAGE_OV}/${draft.NumeroOrdemVenda}`,
            colunsNotNavigate: [7],
            content: [
              <S.StatusWrapper key={`status-${draft.NumeroOrdemVenda}+${index}`}>
                <Status label={label} status={statusType} />
              </S.StatusWrapper>,
              <S.TableInfo key={`number-${draft.NumeroPedidoRascunho}+${index}`}>
                <S.CellItem>
                  {!!draft.NumeroPedidoRascunho && (
                    <>
                      {draft.NumeroPedidoRascunho}
                      <CopyButton text={draft.NumeroPedidoRascunho} />
                    </>
                  )}
                  {getNegDifRowIcon([ovsNegDifInfo])}
                  {getHavaRowIcon(draft.Origem)}
                  {getEDIRowIcon(draft.Origem, undefined, true)}
                </S.CellItem>
                <span>Solicitado em {draft.DataSolicitacaoPedido}</span>
              </S.TableInfo>,
              <S.TableInfo key="number-client-order">
                <S.CellItem>
                  {draft.NumeroPedidoCliente || (
                    <S.UnavailableInfo>Não informado</S.UnavailableInfo>
                  )}
                </S.CellItem>
              </S.TableInfo>,
              <S.TableInfo key={`client-${draft.NumeroPedidoRascunho}+${index}`}>
                {draft.RazaoSocialCliente}
                <span>Código SAP: {draft.CodigoClienteSap}</span>
              </S.TableInfo>,
              <S.TableInfo key={`client-${draft.NumeroOrdemVenda}+${index}`}>
                <S.CellItem>
                  {draft.NumeroOrdemVenda}
                  <CopyButton text={draft.NumeroOrdemVenda} />
                </S.CellItem>
                <S.CellItem>
                  <span>SAP: {draft.NumeroOrdemVendaSap ?? '--'}</span>
                  {draft.NumeroOrdemVendaSap && (
                    <CopyButton text={draft.NumeroOrdemVendaSap} />
                  )}
                </S.CellItem>
              </S.TableInfo>,
              <S.TableInfo key={`client-${draft.NumeroPedidoRascunho}+${index}`}>
                Entrega: {draft.DataEntregaCalculada}
                <span>Faturamento: {draft.DataFaturamentoPrevisto}</span>
              </S.TableInfo>,
              <S.FabInfo key={`${draft.NumeroOrdemVenda} + ${index}`}>
                {draft.CodigoFabrica}
              </S.FabInfo>,
              <S.OvMenu key={`${draft.NumeroOrdemVenda} + ${index}`}>
                <OvMenu
                  ovData={draft}
                  setOvsSapData={setOvsSapData}
                  setCurrentModal={setSapModal}
                />
              </S.OvMenu>
            ]
          }
        })}
        headData={headTable}
      />
      <SapModal
        handleButtonAction={handleOvsSAP}
        sapModal={sapModal}
        setSapModal={setSapModal}
      />
    </>
  )
}

export default ViewByOv
